var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleEnd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 110,
  height: 91,
  fill: "none",
  viewBox: "0 0 110 91"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  d: "M91 24.5H21v22l70-1v-21ZM91 24.5v45h19V.5H91v24Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  fillRule: "evenodd",
  d: "M21 46.5v-22H0V91h21V46.5Z",
  clipRule: "evenodd"
})));
export { SvgAngleEnd as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEwIiBoZWlnaHQ9IjkxIiB2aWV3Qm94PSIwIDAgMTEwIDkxIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNOTEgMjQuNUwyMSAyNC41VjQ2LjVMOTEgNDUuNVYyNC41WiIgZmlsbD0iIzUzNTY1QiIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPHBhdGggZD0iTTkxIDI0LjVWNDUuNVY2OS41SDExMFYwLjVMOTEgMC41MDAwMDJWMjQuNVoiIGZpbGw9IiM1MzU2NUIiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEgNDYuNVYyNC41SDBWOTFIMjFWNDYuNVoiIGZpbGw9IiM1MzU2NUIiIGZpbGwtb3BhY2l0eT0iMC4yIi8+Cjwvc3ZnPgo=";